export default __webpack_public_path__ + "static/media/explain@2x.e14d546d.png";